/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as ProjectsImportRouteImport } from './routes/projects/import'
import { Route as AppStockRouteImport } from './routes/_app/stock'
import { Route as AppReferencesRouteImport } from './routes/_app/references'
import { Route as AppNomenclatureRouteImport } from './routes/_app/nomenclature'
import { Route as AppWorkOrdersIndexRouteImport } from './routes/_app/work-orders/index'
import { Route as AppTransfersIndexRouteImport } from './routes/_app/transfers/index'
import { Route as AppStorekeepingIndexRouteImport } from './routes/_app/storekeeping/index'
import { Route as AppStockReceiptsIndexRouteImport } from './routes/_app/stock-receipts/index'
import { Route as AppReportsIndexRouteImport } from './routes/_app/reports/index'
import { Route as AppReferencesIndexRouteImport } from './routes/_app/references/index'
import { Route as AppProductionReportsIndexRouteImport } from './routes/_app/production-reports/index'
import { Route as AppMaterialIssuesIndexRouteImport } from './routes/_app/material-issues/index'
import { Route as AppGoodsReceiptsIndexRouteImport } from './routes/_app/goods-receipts/index'
import { Route as ProjectsProjectIdLayoutRouteImport } from './routes/projects/$projectId/_layout'
import { Route as AppWorkOrdersWorkOrderIdRouteImport } from './routes/_app/work-orders/$workOrderId'
import { Route as AppTransfersNewRouteImport } from './routes/_app/transfers/new'
import { Route as AppTransfersTransferIdRouteImport } from './routes/_app/transfers/$transferId'
import { Route as AppStockReceiptsStockReceiptIdRouteImport } from './routes/_app/stock-receipts/$stockReceiptId'
import { Route as AppReportsStockMovementsRouteImport } from './routes/_app/reports/stock-movements'
import { Route as AppReportsStockBalancesRouteImport } from './routes/_app/reports/stock-balances'
import { Route as AppReportsMaterialConsumptionRouteImport } from './routes/_app/reports/material-consumption'
import { Route as AppReportsDeficitRouteImport } from './routes/_app/reports/deficit'
import { Route as AppReferencesUsersRouteImport } from './routes/_app/references/users'
import { Route as AppReferencesUnitsRouteImport } from './routes/_app/references/units'
import { Route as AppReferencesPositionsRouteImport } from './routes/_app/references/positions'
import { Route as AppReferencesOperationsRouteImport } from './routes/_app/references/operations'
import { Route as AppProductionReportsProductionReportIdRouteImport } from './routes/_app/production-reports/$productionReportId'
import { Route as AppMaterialIssuesMaterialIssueIdRouteImport } from './routes/_app/material-issues/$materialIssueId'
import { Route as AppGoodsReceiptsGoodsReceiptIdRouteImport } from './routes/_app/goods-receipts/$goodsReceiptId'
import { Route as ProjectsProjectIdLayoutIndexRouteImport } from './routes/projects/$projectId/_layout/index'
import { Route as AppReferencesWarehousesIndexRouteImport } from './routes/_app/references/warehouses/index'
import { Route as ProjectsProjectIdLayoutNomenclatureRouteImport } from './routes/projects/$projectId/_layout/nomenclature'
import { Route as ProjectsProjectIdLayoutDrawingsRouteImport } from './routes/projects/$projectId/_layout/drawings'
import { Route as ProjectsProjectIdLayoutBomRouteImport } from './routes/projects/$projectId/_layout/bom'
import { Route as AppReferencesWarehousesNewRouteImport } from './routes/_app/references/warehouses/new'
import { Route as ProjectsProjectIdLayoutWorkOrdersIndexRouteImport } from './routes/projects/$projectId/_layout/work-orders/index'
import { Route as ProjectsProjectIdLayoutReceiptsIndexRouteImport } from './routes/projects/$projectId/_layout/receipts/index'
import { Route as ProjectsProjectIdLayoutWorkOrdersWorkOrderIdRouteImport } from './routes/projects/$projectId/_layout/work-orders/$workOrderId'
import { Route as ProjectsProjectIdLayoutReceiptsStockReceiptIdRouteImport } from './routes/projects/$projectId/_layout/receipts/$stockReceiptId'
import { Route as AppReferencesWarehousesWarehouseIdEditRouteImport } from './routes/_app/references/warehouses/$warehouseId.edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsImportRoute = ProjectsImportRouteImport.update({
  id: '/projects/import',
  path: '/projects/import',
  getParentRoute: () => rootRouteImport,
} as any)
const AppStockRoute = AppStockRouteImport.update({
  id: '/stock',
  path: '/stock',
  getParentRoute: () => AppRoute,
} as any)
const AppReferencesRoute = AppReferencesRouteImport.update({
  id: '/references',
  path: '/references',
  getParentRoute: () => AppRoute,
} as any)
const AppNomenclatureRoute = AppNomenclatureRouteImport.update({
  id: '/nomenclature',
  path: '/nomenclature',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkOrdersIndexRoute = AppWorkOrdersIndexRouteImport.update({
  id: '/work-orders/',
  path: '/work-orders/',
  getParentRoute: () => AppRoute,
} as any)
const AppTransfersIndexRoute = AppTransfersIndexRouteImport.update({
  id: '/transfers/',
  path: '/transfers/',
  getParentRoute: () => AppRoute,
} as any)
const AppStorekeepingIndexRoute = AppStorekeepingIndexRouteImport.update({
  id: '/storekeeping/',
  path: '/storekeeping/',
  getParentRoute: () => AppRoute,
} as any)
const AppStockReceiptsIndexRoute = AppStockReceiptsIndexRouteImport.update({
  id: '/stock-receipts/',
  path: '/stock-receipts/',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRoute,
} as any)
const AppReferencesIndexRoute = AppReferencesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppReferencesRoute,
} as any)
const AppProductionReportsIndexRoute =
  AppProductionReportsIndexRouteImport.update({
    id: '/production-reports/',
    path: '/production-reports/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMaterialIssuesIndexRoute = AppMaterialIssuesIndexRouteImport.update({
  id: '/material-issues/',
  path: '/material-issues/',
  getParentRoute: () => AppRoute,
} as any)
const AppGoodsReceiptsIndexRoute = AppGoodsReceiptsIndexRouteImport.update({
  id: '/goods-receipts/',
  path: '/goods-receipts/',
  getParentRoute: () => AppRoute,
} as any)
const ProjectsProjectIdLayoutRoute = ProjectsProjectIdLayoutRouteImport.update({
  id: '/projects/$projectId/_layout',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppWorkOrdersWorkOrderIdRoute =
  AppWorkOrdersWorkOrderIdRouteImport.update({
    id: '/work-orders/$workOrderId',
    path: '/work-orders/$workOrderId',
    getParentRoute: () => AppRoute,
  } as any)
const AppTransfersNewRoute = AppTransfersNewRouteImport.update({
  id: '/transfers/new',
  path: '/transfers/new',
  getParentRoute: () => AppRoute,
} as any)
const AppTransfersTransferIdRoute = AppTransfersTransferIdRouteImport.update({
  id: '/transfers/$transferId',
  path: '/transfers/$transferId',
  getParentRoute: () => AppRoute,
} as any)
const AppStockReceiptsStockReceiptIdRoute =
  AppStockReceiptsStockReceiptIdRouteImport.update({
    id: '/stock-receipts/$stockReceiptId',
    path: '/stock-receipts/$stockReceiptId',
    getParentRoute: () => AppRoute,
  } as any)
const AppReportsStockMovementsRoute =
  AppReportsStockMovementsRouteImport.update({
    id: '/reports/stock-movements',
    path: '/reports/stock-movements',
    getParentRoute: () => AppRoute,
  } as any)
const AppReportsStockBalancesRoute = AppReportsStockBalancesRouteImport.update({
  id: '/reports/stock-balances',
  path: '/reports/stock-balances',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsMaterialConsumptionRoute =
  AppReportsMaterialConsumptionRouteImport.update({
    id: '/reports/material-consumption',
    path: '/reports/material-consumption',
    getParentRoute: () => AppRoute,
  } as any)
const AppReportsDeficitRoute = AppReportsDeficitRouteImport.update({
  id: '/reports/deficit',
  path: '/reports/deficit',
  getParentRoute: () => AppRoute,
} as any)
const AppReferencesUsersRoute = AppReferencesUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppReferencesRoute,
} as any)
const AppReferencesUnitsRoute = AppReferencesUnitsRouteImport.update({
  id: '/units',
  path: '/units',
  getParentRoute: () => AppReferencesRoute,
} as any)
const AppReferencesPositionsRoute = AppReferencesPositionsRouteImport.update({
  id: '/positions',
  path: '/positions',
  getParentRoute: () => AppReferencesRoute,
} as any)
const AppReferencesOperationsRoute = AppReferencesOperationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => AppReferencesRoute,
} as any)
const AppProductionReportsProductionReportIdRoute =
  AppProductionReportsProductionReportIdRouteImport.update({
    id: '/production-reports/$productionReportId',
    path: '/production-reports/$productionReportId',
    getParentRoute: () => AppRoute,
  } as any)
const AppMaterialIssuesMaterialIssueIdRoute =
  AppMaterialIssuesMaterialIssueIdRouteImport.update({
    id: '/material-issues/$materialIssueId',
    path: '/material-issues/$materialIssueId',
    getParentRoute: () => AppRoute,
  } as any)
const AppGoodsReceiptsGoodsReceiptIdRoute =
  AppGoodsReceiptsGoodsReceiptIdRouteImport.update({
    id: '/goods-receipts/$goodsReceiptId',
    path: '/goods-receipts/$goodsReceiptId',
    getParentRoute: () => AppRoute,
  } as any)
const ProjectsProjectIdLayoutIndexRoute =
  ProjectsProjectIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProjectsProjectIdLayoutRoute,
  } as any)
const AppReferencesWarehousesIndexRoute =
  AppReferencesWarehousesIndexRouteImport.update({
    id: '/warehouses/',
    path: '/warehouses/',
    getParentRoute: () => AppReferencesRoute,
  } as any)
const ProjectsProjectIdLayoutNomenclatureRoute =
  ProjectsProjectIdLayoutNomenclatureRouteImport.update({
    id: '/nomenclature',
    path: '/nomenclature',
    getParentRoute: () => ProjectsProjectIdLayoutRoute,
  } as any)
const ProjectsProjectIdLayoutDrawingsRoute =
  ProjectsProjectIdLayoutDrawingsRouteImport.update({
    id: '/drawings',
    path: '/drawings',
    getParentRoute: () => ProjectsProjectIdLayoutRoute,
  } as any)
const ProjectsProjectIdLayoutBomRoute =
  ProjectsProjectIdLayoutBomRouteImport.update({
    id: '/bom',
    path: '/bom',
    getParentRoute: () => ProjectsProjectIdLayoutRoute,
  } as any)
const AppReferencesWarehousesNewRoute =
  AppReferencesWarehousesNewRouteImport.update({
    id: '/warehouses/new',
    path: '/warehouses/new',
    getParentRoute: () => AppReferencesRoute,
  } as any)
const ProjectsProjectIdLayoutWorkOrdersIndexRoute =
  ProjectsProjectIdLayoutWorkOrdersIndexRouteImport.update({
    id: '/work-orders/',
    path: '/work-orders/',
    getParentRoute: () => ProjectsProjectIdLayoutRoute,
  } as any)
const ProjectsProjectIdLayoutReceiptsIndexRoute =
  ProjectsProjectIdLayoutReceiptsIndexRouteImport.update({
    id: '/receipts/',
    path: '/receipts/',
    getParentRoute: () => ProjectsProjectIdLayoutRoute,
  } as any)
const ProjectsProjectIdLayoutWorkOrdersWorkOrderIdRoute =
  ProjectsProjectIdLayoutWorkOrdersWorkOrderIdRouteImport.update({
    id: '/work-orders/$workOrderId',
    path: '/work-orders/$workOrderId',
    getParentRoute: () => ProjectsProjectIdLayoutRoute,
  } as any)
const ProjectsProjectIdLayoutReceiptsStockReceiptIdRoute =
  ProjectsProjectIdLayoutReceiptsStockReceiptIdRouteImport.update({
    id: '/receipts/$stockReceiptId',
    path: '/receipts/$stockReceiptId',
    getParentRoute: () => ProjectsProjectIdLayoutRoute,
  } as any)
const AppReferencesWarehousesWarehouseIdEditRoute =
  AppReferencesWarehousesWarehouseIdEditRouteImport.update({
    id: '/warehouses/$warehouseId/edit',
    path: '/warehouses/$warehouseId/edit',
    getParentRoute: () => AppReferencesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/nomenclature': typeof AppNomenclatureRoute
  '/references': typeof AppReferencesRouteWithChildren
  '/stock': typeof AppStockRoute
  '/projects/import': typeof ProjectsImportRoute
  '/projects/': typeof ProjectsIndexRoute
  '/goods-receipts/$goodsReceiptId': typeof AppGoodsReceiptsGoodsReceiptIdRoute
  '/material-issues/$materialIssueId': typeof AppMaterialIssuesMaterialIssueIdRoute
  '/production-reports/$productionReportId': typeof AppProductionReportsProductionReportIdRoute
  '/references/operations': typeof AppReferencesOperationsRoute
  '/references/positions': typeof AppReferencesPositionsRoute
  '/references/units': typeof AppReferencesUnitsRoute
  '/references/users': typeof AppReferencesUsersRoute
  '/reports/deficit': typeof AppReportsDeficitRoute
  '/reports/material-consumption': typeof AppReportsMaterialConsumptionRoute
  '/reports/stock-balances': typeof AppReportsStockBalancesRoute
  '/reports/stock-movements': typeof AppReportsStockMovementsRoute
  '/stock-receipts/$stockReceiptId': typeof AppStockReceiptsStockReceiptIdRoute
  '/transfers/$transferId': typeof AppTransfersTransferIdRoute
  '/transfers/new': typeof AppTransfersNewRoute
  '/work-orders/$workOrderId': typeof AppWorkOrdersWorkOrderIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdLayoutRouteWithChildren
  '/goods-receipts/': typeof AppGoodsReceiptsIndexRoute
  '/material-issues/': typeof AppMaterialIssuesIndexRoute
  '/production-reports/': typeof AppProductionReportsIndexRoute
  '/references/': typeof AppReferencesIndexRoute
  '/reports/': typeof AppReportsIndexRoute
  '/stock-receipts/': typeof AppStockReceiptsIndexRoute
  '/storekeeping/': typeof AppStorekeepingIndexRoute
  '/transfers/': typeof AppTransfersIndexRoute
  '/work-orders/': typeof AppWorkOrdersIndexRoute
  '/references/warehouses/new': typeof AppReferencesWarehousesNewRoute
  '/projects/$projectId/bom': typeof ProjectsProjectIdLayoutBomRoute
  '/projects/$projectId/drawings': typeof ProjectsProjectIdLayoutDrawingsRoute
  '/projects/$projectId/nomenclature': typeof ProjectsProjectIdLayoutNomenclatureRoute
  '/references/warehouses/': typeof AppReferencesWarehousesIndexRoute
  '/projects/$projectId/': typeof ProjectsProjectIdLayoutIndexRoute
  '/references/warehouses/$warehouseId/edit': typeof AppReferencesWarehousesWarehouseIdEditRoute
  '/projects/$projectId/receipts/$stockReceiptId': typeof ProjectsProjectIdLayoutReceiptsStockReceiptIdRoute
  '/projects/$projectId/work-orders/$workOrderId': typeof ProjectsProjectIdLayoutWorkOrdersWorkOrderIdRoute
  '/projects/$projectId/receipts/': typeof ProjectsProjectIdLayoutReceiptsIndexRoute
  '/projects/$projectId/work-orders/': typeof ProjectsProjectIdLayoutWorkOrdersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/nomenclature': typeof AppNomenclatureRoute
  '/stock': typeof AppStockRoute
  '/projects/import': typeof ProjectsImportRoute
  '/projects': typeof ProjectsIndexRoute
  '/goods-receipts/$goodsReceiptId': typeof AppGoodsReceiptsGoodsReceiptIdRoute
  '/material-issues/$materialIssueId': typeof AppMaterialIssuesMaterialIssueIdRoute
  '/production-reports/$productionReportId': typeof AppProductionReportsProductionReportIdRoute
  '/references/operations': typeof AppReferencesOperationsRoute
  '/references/positions': typeof AppReferencesPositionsRoute
  '/references/units': typeof AppReferencesUnitsRoute
  '/references/users': typeof AppReferencesUsersRoute
  '/reports/deficit': typeof AppReportsDeficitRoute
  '/reports/material-consumption': typeof AppReportsMaterialConsumptionRoute
  '/reports/stock-balances': typeof AppReportsStockBalancesRoute
  '/reports/stock-movements': typeof AppReportsStockMovementsRoute
  '/stock-receipts/$stockReceiptId': typeof AppStockReceiptsStockReceiptIdRoute
  '/transfers/$transferId': typeof AppTransfersTransferIdRoute
  '/transfers/new': typeof AppTransfersNewRoute
  '/work-orders/$workOrderId': typeof AppWorkOrdersWorkOrderIdRoute
  '/goods-receipts': typeof AppGoodsReceiptsIndexRoute
  '/material-issues': typeof AppMaterialIssuesIndexRoute
  '/production-reports': typeof AppProductionReportsIndexRoute
  '/references': typeof AppReferencesIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/stock-receipts': typeof AppStockReceiptsIndexRoute
  '/storekeeping': typeof AppStorekeepingIndexRoute
  '/transfers': typeof AppTransfersIndexRoute
  '/work-orders': typeof AppWorkOrdersIndexRoute
  '/references/warehouses/new': typeof AppReferencesWarehousesNewRoute
  '/projects/$projectId/bom': typeof ProjectsProjectIdLayoutBomRoute
  '/projects/$projectId/drawings': typeof ProjectsProjectIdLayoutDrawingsRoute
  '/projects/$projectId/nomenclature': typeof ProjectsProjectIdLayoutNomenclatureRoute
  '/references/warehouses': typeof AppReferencesWarehousesIndexRoute
  '/projects/$projectId': typeof ProjectsProjectIdLayoutIndexRoute
  '/references/warehouses/$warehouseId/edit': typeof AppReferencesWarehousesWarehouseIdEditRoute
  '/projects/$projectId/receipts/$stockReceiptId': typeof ProjectsProjectIdLayoutReceiptsStockReceiptIdRoute
  '/projects/$projectId/work-orders/$workOrderId': typeof ProjectsProjectIdLayoutWorkOrdersWorkOrderIdRoute
  '/projects/$projectId/receipts': typeof ProjectsProjectIdLayoutReceiptsIndexRoute
  '/projects/$projectId/work-orders': typeof ProjectsProjectIdLayoutWorkOrdersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/nomenclature': typeof AppNomenclatureRoute
  '/_app/references': typeof AppReferencesRouteWithChildren
  '/_app/stock': typeof AppStockRoute
  '/projects/import': typeof ProjectsImportRoute
  '/projects/': typeof ProjectsIndexRoute
  '/_app/goods-receipts/$goodsReceiptId': typeof AppGoodsReceiptsGoodsReceiptIdRoute
  '/_app/material-issues/$materialIssueId': typeof AppMaterialIssuesMaterialIssueIdRoute
  '/_app/production-reports/$productionReportId': typeof AppProductionReportsProductionReportIdRoute
  '/_app/references/operations': typeof AppReferencesOperationsRoute
  '/_app/references/positions': typeof AppReferencesPositionsRoute
  '/_app/references/units': typeof AppReferencesUnitsRoute
  '/_app/references/users': typeof AppReferencesUsersRoute
  '/_app/reports/deficit': typeof AppReportsDeficitRoute
  '/_app/reports/material-consumption': typeof AppReportsMaterialConsumptionRoute
  '/_app/reports/stock-balances': typeof AppReportsStockBalancesRoute
  '/_app/reports/stock-movements': typeof AppReportsStockMovementsRoute
  '/_app/stock-receipts/$stockReceiptId': typeof AppStockReceiptsStockReceiptIdRoute
  '/_app/transfers/$transferId': typeof AppTransfersTransferIdRoute
  '/_app/transfers/new': typeof AppTransfersNewRoute
  '/_app/work-orders/$workOrderId': typeof AppWorkOrdersWorkOrderIdRoute
  '/projects/$projectId/_layout': typeof ProjectsProjectIdLayoutRouteWithChildren
  '/_app/goods-receipts/': typeof AppGoodsReceiptsIndexRoute
  '/_app/material-issues/': typeof AppMaterialIssuesIndexRoute
  '/_app/production-reports/': typeof AppProductionReportsIndexRoute
  '/_app/references/': typeof AppReferencesIndexRoute
  '/_app/reports/': typeof AppReportsIndexRoute
  '/_app/stock-receipts/': typeof AppStockReceiptsIndexRoute
  '/_app/storekeeping/': typeof AppStorekeepingIndexRoute
  '/_app/transfers/': typeof AppTransfersIndexRoute
  '/_app/work-orders/': typeof AppWorkOrdersIndexRoute
  '/_app/references/warehouses/new': typeof AppReferencesWarehousesNewRoute
  '/projects/$projectId/_layout/bom': typeof ProjectsProjectIdLayoutBomRoute
  '/projects/$projectId/_layout/drawings': typeof ProjectsProjectIdLayoutDrawingsRoute
  '/projects/$projectId/_layout/nomenclature': typeof ProjectsProjectIdLayoutNomenclatureRoute
  '/_app/references/warehouses/': typeof AppReferencesWarehousesIndexRoute
  '/projects/$projectId/_layout/': typeof ProjectsProjectIdLayoutIndexRoute
  '/_app/references/warehouses/$warehouseId/edit': typeof AppReferencesWarehousesWarehouseIdEditRoute
  '/projects/$projectId/_layout/receipts/$stockReceiptId': typeof ProjectsProjectIdLayoutReceiptsStockReceiptIdRoute
  '/projects/$projectId/_layout/work-orders/$workOrderId': typeof ProjectsProjectIdLayoutWorkOrdersWorkOrderIdRoute
  '/projects/$projectId/_layout/receipts/': typeof ProjectsProjectIdLayoutReceiptsIndexRoute
  '/projects/$projectId/_layout/work-orders/': typeof ProjectsProjectIdLayoutWorkOrdersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/nomenclature'
    | '/references'
    | '/stock'
    | '/projects/import'
    | '/projects/'
    | '/goods-receipts/$goodsReceiptId'
    | '/material-issues/$materialIssueId'
    | '/production-reports/$productionReportId'
    | '/references/operations'
    | '/references/positions'
    | '/references/units'
    | '/references/users'
    | '/reports/deficit'
    | '/reports/material-consumption'
    | '/reports/stock-balances'
    | '/reports/stock-movements'
    | '/stock-receipts/$stockReceiptId'
    | '/transfers/$transferId'
    | '/transfers/new'
    | '/work-orders/$workOrderId'
    | '/projects/$projectId'
    | '/goods-receipts/'
    | '/material-issues/'
    | '/production-reports/'
    | '/references/'
    | '/reports/'
    | '/stock-receipts/'
    | '/storekeeping/'
    | '/transfers/'
    | '/work-orders/'
    | '/references/warehouses/new'
    | '/projects/$projectId/bom'
    | '/projects/$projectId/drawings'
    | '/projects/$projectId/nomenclature'
    | '/references/warehouses/'
    | '/projects/$projectId/'
    | '/references/warehouses/$warehouseId/edit'
    | '/projects/$projectId/receipts/$stockReceiptId'
    | '/projects/$projectId/work-orders/$workOrderId'
    | '/projects/$projectId/receipts/'
    | '/projects/$projectId/work-orders/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/nomenclature'
    | '/stock'
    | '/projects/import'
    | '/projects'
    | '/goods-receipts/$goodsReceiptId'
    | '/material-issues/$materialIssueId'
    | '/production-reports/$productionReportId'
    | '/references/operations'
    | '/references/positions'
    | '/references/units'
    | '/references/users'
    | '/reports/deficit'
    | '/reports/material-consumption'
    | '/reports/stock-balances'
    | '/reports/stock-movements'
    | '/stock-receipts/$stockReceiptId'
    | '/transfers/$transferId'
    | '/transfers/new'
    | '/work-orders/$workOrderId'
    | '/goods-receipts'
    | '/material-issues'
    | '/production-reports'
    | '/references'
    | '/reports'
    | '/stock-receipts'
    | '/storekeeping'
    | '/transfers'
    | '/work-orders'
    | '/references/warehouses/new'
    | '/projects/$projectId/bom'
    | '/projects/$projectId/drawings'
    | '/projects/$projectId/nomenclature'
    | '/references/warehouses'
    | '/projects/$projectId'
    | '/references/warehouses/$warehouseId/edit'
    | '/projects/$projectId/receipts/$stockReceiptId'
    | '/projects/$projectId/work-orders/$workOrderId'
    | '/projects/$projectId/receipts'
    | '/projects/$projectId/work-orders'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/_app/nomenclature'
    | '/_app/references'
    | '/_app/stock'
    | '/projects/import'
    | '/projects/'
    | '/_app/goods-receipts/$goodsReceiptId'
    | '/_app/material-issues/$materialIssueId'
    | '/_app/production-reports/$productionReportId'
    | '/_app/references/operations'
    | '/_app/references/positions'
    | '/_app/references/units'
    | '/_app/references/users'
    | '/_app/reports/deficit'
    | '/_app/reports/material-consumption'
    | '/_app/reports/stock-balances'
    | '/_app/reports/stock-movements'
    | '/_app/stock-receipts/$stockReceiptId'
    | '/_app/transfers/$transferId'
    | '/_app/transfers/new'
    | '/_app/work-orders/$workOrderId'
    | '/projects/$projectId/_layout'
    | '/_app/goods-receipts/'
    | '/_app/material-issues/'
    | '/_app/production-reports/'
    | '/_app/references/'
    | '/_app/reports/'
    | '/_app/stock-receipts/'
    | '/_app/storekeeping/'
    | '/_app/transfers/'
    | '/_app/work-orders/'
    | '/_app/references/warehouses/new'
    | '/projects/$projectId/_layout/bom'
    | '/projects/$projectId/_layout/drawings'
    | '/projects/$projectId/_layout/nomenclature'
    | '/_app/references/warehouses/'
    | '/projects/$projectId/_layout/'
    | '/_app/references/warehouses/$warehouseId/edit'
    | '/projects/$projectId/_layout/receipts/$stockReceiptId'
    | '/projects/$projectId/_layout/work-orders/$workOrderId'
    | '/projects/$projectId/_layout/receipts/'
    | '/projects/$projectId/_layout/work-orders/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  ProjectsImportRoute: typeof ProjectsImportRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  ProjectsProjectIdLayoutRoute: typeof ProjectsProjectIdLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/import': {
      id: '/projects/import'
      path: '/projects/import'
      fullPath: '/projects/import'
      preLoaderRoute: typeof ProjectsImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/stock': {
      id: '/_app/stock'
      path: '/stock'
      fullPath: '/stock'
      preLoaderRoute: typeof AppStockRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/references': {
      id: '/_app/references'
      path: '/references'
      fullPath: '/references'
      preLoaderRoute: typeof AppReferencesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/nomenclature': {
      id: '/_app/nomenclature'
      path: '/nomenclature'
      fullPath: '/nomenclature'
      preLoaderRoute: typeof AppNomenclatureRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/work-orders/': {
      id: '/_app/work-orders/'
      path: '/work-orders'
      fullPath: '/work-orders/'
      preLoaderRoute: typeof AppWorkOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transfers/': {
      id: '/_app/transfers/'
      path: '/transfers'
      fullPath: '/transfers/'
      preLoaderRoute: typeof AppTransfersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/storekeeping/': {
      id: '/_app/storekeeping/'
      path: '/storekeeping'
      fullPath: '/storekeeping/'
      preLoaderRoute: typeof AppStorekeepingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-receipts/': {
      id: '/_app/stock-receipts/'
      path: '/stock-receipts'
      fullPath: '/stock-receipts/'
      preLoaderRoute: typeof AppStockReceiptsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/': {
      id: '/_app/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/references/': {
      id: '/_app/references/'
      path: '/'
      fullPath: '/references/'
      preLoaderRoute: typeof AppReferencesIndexRouteImport
      parentRoute: typeof AppReferencesRoute
    }
    '/_app/production-reports/': {
      id: '/_app/production-reports/'
      path: '/production-reports'
      fullPath: '/production-reports/'
      preLoaderRoute: typeof AppProductionReportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/material-issues/': {
      id: '/_app/material-issues/'
      path: '/material-issues'
      fullPath: '/material-issues/'
      preLoaderRoute: typeof AppMaterialIssuesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/goods-receipts/': {
      id: '/_app/goods-receipts/'
      path: '/goods-receipts'
      fullPath: '/goods-receipts/'
      preLoaderRoute: typeof AppGoodsReceiptsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/projects/$projectId/_layout': {
      id: '/projects/$projectId/_layout'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/work-orders/$workOrderId': {
      id: '/_app/work-orders/$workOrderId'
      path: '/work-orders/$workOrderId'
      fullPath: '/work-orders/$workOrderId'
      preLoaderRoute: typeof AppWorkOrdersWorkOrderIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transfers/new': {
      id: '/_app/transfers/new'
      path: '/transfers/new'
      fullPath: '/transfers/new'
      preLoaderRoute: typeof AppTransfersNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transfers/$transferId': {
      id: '/_app/transfers/$transferId'
      path: '/transfers/$transferId'
      fullPath: '/transfers/$transferId'
      preLoaderRoute: typeof AppTransfersTransferIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-receipts/$stockReceiptId': {
      id: '/_app/stock-receipts/$stockReceiptId'
      path: '/stock-receipts/$stockReceiptId'
      fullPath: '/stock-receipts/$stockReceiptId'
      preLoaderRoute: typeof AppStockReceiptsStockReceiptIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/stock-movements': {
      id: '/_app/reports/stock-movements'
      path: '/reports/stock-movements'
      fullPath: '/reports/stock-movements'
      preLoaderRoute: typeof AppReportsStockMovementsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/stock-balances': {
      id: '/_app/reports/stock-balances'
      path: '/reports/stock-balances'
      fullPath: '/reports/stock-balances'
      preLoaderRoute: typeof AppReportsStockBalancesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/material-consumption': {
      id: '/_app/reports/material-consumption'
      path: '/reports/material-consumption'
      fullPath: '/reports/material-consumption'
      preLoaderRoute: typeof AppReportsMaterialConsumptionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/deficit': {
      id: '/_app/reports/deficit'
      path: '/reports/deficit'
      fullPath: '/reports/deficit'
      preLoaderRoute: typeof AppReportsDeficitRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/references/users': {
      id: '/_app/references/users'
      path: '/users'
      fullPath: '/references/users'
      preLoaderRoute: typeof AppReferencesUsersRouteImport
      parentRoute: typeof AppReferencesRoute
    }
    '/_app/references/units': {
      id: '/_app/references/units'
      path: '/units'
      fullPath: '/references/units'
      preLoaderRoute: typeof AppReferencesUnitsRouteImport
      parentRoute: typeof AppReferencesRoute
    }
    '/_app/references/positions': {
      id: '/_app/references/positions'
      path: '/positions'
      fullPath: '/references/positions'
      preLoaderRoute: typeof AppReferencesPositionsRouteImport
      parentRoute: typeof AppReferencesRoute
    }
    '/_app/references/operations': {
      id: '/_app/references/operations'
      path: '/operations'
      fullPath: '/references/operations'
      preLoaderRoute: typeof AppReferencesOperationsRouteImport
      parentRoute: typeof AppReferencesRoute
    }
    '/_app/production-reports/$productionReportId': {
      id: '/_app/production-reports/$productionReportId'
      path: '/production-reports/$productionReportId'
      fullPath: '/production-reports/$productionReportId'
      preLoaderRoute: typeof AppProductionReportsProductionReportIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/material-issues/$materialIssueId': {
      id: '/_app/material-issues/$materialIssueId'
      path: '/material-issues/$materialIssueId'
      fullPath: '/material-issues/$materialIssueId'
      preLoaderRoute: typeof AppMaterialIssuesMaterialIssueIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/goods-receipts/$goodsReceiptId': {
      id: '/_app/goods-receipts/$goodsReceiptId'
      path: '/goods-receipts/$goodsReceiptId'
      fullPath: '/goods-receipts/$goodsReceiptId'
      preLoaderRoute: typeof AppGoodsReceiptsGoodsReceiptIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/projects/$projectId/_layout/': {
      id: '/projects/$projectId/_layout/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof ProjectsProjectIdLayoutIndexRouteImport
      parentRoute: typeof ProjectsProjectIdLayoutRoute
    }
    '/_app/references/warehouses/': {
      id: '/_app/references/warehouses/'
      path: '/warehouses'
      fullPath: '/references/warehouses/'
      preLoaderRoute: typeof AppReferencesWarehousesIndexRouteImport
      parentRoute: typeof AppReferencesRoute
    }
    '/projects/$projectId/_layout/nomenclature': {
      id: '/projects/$projectId/_layout/nomenclature'
      path: '/nomenclature'
      fullPath: '/projects/$projectId/nomenclature'
      preLoaderRoute: typeof ProjectsProjectIdLayoutNomenclatureRouteImport
      parentRoute: typeof ProjectsProjectIdLayoutRoute
    }
    '/projects/$projectId/_layout/drawings': {
      id: '/projects/$projectId/_layout/drawings'
      path: '/drawings'
      fullPath: '/projects/$projectId/drawings'
      preLoaderRoute: typeof ProjectsProjectIdLayoutDrawingsRouteImport
      parentRoute: typeof ProjectsProjectIdLayoutRoute
    }
    '/projects/$projectId/_layout/bom': {
      id: '/projects/$projectId/_layout/bom'
      path: '/bom'
      fullPath: '/projects/$projectId/bom'
      preLoaderRoute: typeof ProjectsProjectIdLayoutBomRouteImport
      parentRoute: typeof ProjectsProjectIdLayoutRoute
    }
    '/_app/references/warehouses/new': {
      id: '/_app/references/warehouses/new'
      path: '/warehouses/new'
      fullPath: '/references/warehouses/new'
      preLoaderRoute: typeof AppReferencesWarehousesNewRouteImport
      parentRoute: typeof AppReferencesRoute
    }
    '/projects/$projectId/_layout/work-orders/': {
      id: '/projects/$projectId/_layout/work-orders/'
      path: '/work-orders'
      fullPath: '/projects/$projectId/work-orders/'
      preLoaderRoute: typeof ProjectsProjectIdLayoutWorkOrdersIndexRouteImport
      parentRoute: typeof ProjectsProjectIdLayoutRoute
    }
    '/projects/$projectId/_layout/receipts/': {
      id: '/projects/$projectId/_layout/receipts/'
      path: '/receipts'
      fullPath: '/projects/$projectId/receipts/'
      preLoaderRoute: typeof ProjectsProjectIdLayoutReceiptsIndexRouteImport
      parentRoute: typeof ProjectsProjectIdLayoutRoute
    }
    '/projects/$projectId/_layout/work-orders/$workOrderId': {
      id: '/projects/$projectId/_layout/work-orders/$workOrderId'
      path: '/work-orders/$workOrderId'
      fullPath: '/projects/$projectId/work-orders/$workOrderId'
      preLoaderRoute: typeof ProjectsProjectIdLayoutWorkOrdersWorkOrderIdRouteImport
      parentRoute: typeof ProjectsProjectIdLayoutRoute
    }
    '/projects/$projectId/_layout/receipts/$stockReceiptId': {
      id: '/projects/$projectId/_layout/receipts/$stockReceiptId'
      path: '/receipts/$stockReceiptId'
      fullPath: '/projects/$projectId/receipts/$stockReceiptId'
      preLoaderRoute: typeof ProjectsProjectIdLayoutReceiptsStockReceiptIdRouteImport
      parentRoute: typeof ProjectsProjectIdLayoutRoute
    }
    '/_app/references/warehouses/$warehouseId/edit': {
      id: '/_app/references/warehouses/$warehouseId/edit'
      path: '/warehouses/$warehouseId/edit'
      fullPath: '/references/warehouses/$warehouseId/edit'
      preLoaderRoute: typeof AppReferencesWarehousesWarehouseIdEditRouteImport
      parentRoute: typeof AppReferencesRoute
    }
  }
}

interface AppReferencesRouteChildren {
  AppReferencesOperationsRoute: typeof AppReferencesOperationsRoute
  AppReferencesPositionsRoute: typeof AppReferencesPositionsRoute
  AppReferencesUnitsRoute: typeof AppReferencesUnitsRoute
  AppReferencesUsersRoute: typeof AppReferencesUsersRoute
  AppReferencesIndexRoute: typeof AppReferencesIndexRoute
  AppReferencesWarehousesNewRoute: typeof AppReferencesWarehousesNewRoute
  AppReferencesWarehousesIndexRoute: typeof AppReferencesWarehousesIndexRoute
  AppReferencesWarehousesWarehouseIdEditRoute: typeof AppReferencesWarehousesWarehouseIdEditRoute
}

const AppReferencesRouteChildren: AppReferencesRouteChildren = {
  AppReferencesOperationsRoute: AppReferencesOperationsRoute,
  AppReferencesPositionsRoute: AppReferencesPositionsRoute,
  AppReferencesUnitsRoute: AppReferencesUnitsRoute,
  AppReferencesUsersRoute: AppReferencesUsersRoute,
  AppReferencesIndexRoute: AppReferencesIndexRoute,
  AppReferencesWarehousesNewRoute: AppReferencesWarehousesNewRoute,
  AppReferencesWarehousesIndexRoute: AppReferencesWarehousesIndexRoute,
  AppReferencesWarehousesWarehouseIdEditRoute:
    AppReferencesWarehousesWarehouseIdEditRoute,
}

const AppReferencesRouteWithChildren = AppReferencesRoute._addFileChildren(
  AppReferencesRouteChildren,
)

interface AppRouteChildren {
  AppNomenclatureRoute: typeof AppNomenclatureRoute
  AppReferencesRoute: typeof AppReferencesRouteWithChildren
  AppStockRoute: typeof AppStockRoute
  AppGoodsReceiptsGoodsReceiptIdRoute: typeof AppGoodsReceiptsGoodsReceiptIdRoute
  AppMaterialIssuesMaterialIssueIdRoute: typeof AppMaterialIssuesMaterialIssueIdRoute
  AppProductionReportsProductionReportIdRoute: typeof AppProductionReportsProductionReportIdRoute
  AppReportsDeficitRoute: typeof AppReportsDeficitRoute
  AppReportsMaterialConsumptionRoute: typeof AppReportsMaterialConsumptionRoute
  AppReportsStockBalancesRoute: typeof AppReportsStockBalancesRoute
  AppReportsStockMovementsRoute: typeof AppReportsStockMovementsRoute
  AppStockReceiptsStockReceiptIdRoute: typeof AppStockReceiptsStockReceiptIdRoute
  AppTransfersTransferIdRoute: typeof AppTransfersTransferIdRoute
  AppTransfersNewRoute: typeof AppTransfersNewRoute
  AppWorkOrdersWorkOrderIdRoute: typeof AppWorkOrdersWorkOrderIdRoute
  AppGoodsReceiptsIndexRoute: typeof AppGoodsReceiptsIndexRoute
  AppMaterialIssuesIndexRoute: typeof AppMaterialIssuesIndexRoute
  AppProductionReportsIndexRoute: typeof AppProductionReportsIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppStockReceiptsIndexRoute: typeof AppStockReceiptsIndexRoute
  AppStorekeepingIndexRoute: typeof AppStorekeepingIndexRoute
  AppTransfersIndexRoute: typeof AppTransfersIndexRoute
  AppWorkOrdersIndexRoute: typeof AppWorkOrdersIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppNomenclatureRoute: AppNomenclatureRoute,
  AppReferencesRoute: AppReferencesRouteWithChildren,
  AppStockRoute: AppStockRoute,
  AppGoodsReceiptsGoodsReceiptIdRoute: AppGoodsReceiptsGoodsReceiptIdRoute,
  AppMaterialIssuesMaterialIssueIdRoute: AppMaterialIssuesMaterialIssueIdRoute,
  AppProductionReportsProductionReportIdRoute:
    AppProductionReportsProductionReportIdRoute,
  AppReportsDeficitRoute: AppReportsDeficitRoute,
  AppReportsMaterialConsumptionRoute: AppReportsMaterialConsumptionRoute,
  AppReportsStockBalancesRoute: AppReportsStockBalancesRoute,
  AppReportsStockMovementsRoute: AppReportsStockMovementsRoute,
  AppStockReceiptsStockReceiptIdRoute: AppStockReceiptsStockReceiptIdRoute,
  AppTransfersTransferIdRoute: AppTransfersTransferIdRoute,
  AppTransfersNewRoute: AppTransfersNewRoute,
  AppWorkOrdersWorkOrderIdRoute: AppWorkOrdersWorkOrderIdRoute,
  AppGoodsReceiptsIndexRoute: AppGoodsReceiptsIndexRoute,
  AppMaterialIssuesIndexRoute: AppMaterialIssuesIndexRoute,
  AppProductionReportsIndexRoute: AppProductionReportsIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppStockReceiptsIndexRoute: AppStockReceiptsIndexRoute,
  AppStorekeepingIndexRoute: AppStorekeepingIndexRoute,
  AppTransfersIndexRoute: AppTransfersIndexRoute,
  AppWorkOrdersIndexRoute: AppWorkOrdersIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface ProjectsProjectIdLayoutRouteChildren {
  ProjectsProjectIdLayoutBomRoute: typeof ProjectsProjectIdLayoutBomRoute
  ProjectsProjectIdLayoutDrawingsRoute: typeof ProjectsProjectIdLayoutDrawingsRoute
  ProjectsProjectIdLayoutNomenclatureRoute: typeof ProjectsProjectIdLayoutNomenclatureRoute
  ProjectsProjectIdLayoutIndexRoute: typeof ProjectsProjectIdLayoutIndexRoute
  ProjectsProjectIdLayoutReceiptsStockReceiptIdRoute: typeof ProjectsProjectIdLayoutReceiptsStockReceiptIdRoute
  ProjectsProjectIdLayoutWorkOrdersWorkOrderIdRoute: typeof ProjectsProjectIdLayoutWorkOrdersWorkOrderIdRoute
  ProjectsProjectIdLayoutReceiptsIndexRoute: typeof ProjectsProjectIdLayoutReceiptsIndexRoute
  ProjectsProjectIdLayoutWorkOrdersIndexRoute: typeof ProjectsProjectIdLayoutWorkOrdersIndexRoute
}

const ProjectsProjectIdLayoutRouteChildren: ProjectsProjectIdLayoutRouteChildren =
  {
    ProjectsProjectIdLayoutBomRoute: ProjectsProjectIdLayoutBomRoute,
    ProjectsProjectIdLayoutDrawingsRoute: ProjectsProjectIdLayoutDrawingsRoute,
    ProjectsProjectIdLayoutNomenclatureRoute:
      ProjectsProjectIdLayoutNomenclatureRoute,
    ProjectsProjectIdLayoutIndexRoute: ProjectsProjectIdLayoutIndexRoute,
    ProjectsProjectIdLayoutReceiptsStockReceiptIdRoute:
      ProjectsProjectIdLayoutReceiptsStockReceiptIdRoute,
    ProjectsProjectIdLayoutWorkOrdersWorkOrderIdRoute:
      ProjectsProjectIdLayoutWorkOrdersWorkOrderIdRoute,
    ProjectsProjectIdLayoutReceiptsIndexRoute:
      ProjectsProjectIdLayoutReceiptsIndexRoute,
    ProjectsProjectIdLayoutWorkOrdersIndexRoute:
      ProjectsProjectIdLayoutWorkOrdersIndexRoute,
  }

const ProjectsProjectIdLayoutRouteWithChildren =
  ProjectsProjectIdLayoutRoute._addFileChildren(
    ProjectsProjectIdLayoutRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  ProjectsImportRoute: ProjectsImportRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  ProjectsProjectIdLayoutRoute: ProjectsProjectIdLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
